import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { TweenMax, Quint } from 'gsap';
import * as moment from 'moment';
import { Transfer } from '../../models/transfer';
import { EventTypes } from '../../../shared/EventTypes';
import { TransfersOmniService } from '../transfers-omni.service';
import { TransfersOmniEventType } from '../transfers-omni.event.type';
import { ModalErrorEventType } from '../../../shared/modal-error/modal-error.event.type';
import { Auth } from '../../../autentication/Auth';

@Component({
	selector: 'app-transfers-to-omni',
	templateUrl: './transfers-to-omni.component.html',
	styleUrls: ['./transfers-to-omni.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class TransfersToOmniComponent implements OnInit, OnDestroy {

	@Input() flow: string;
	@Input() submited = false;
	@Input() transferData: Transfer;

	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
	public form: FormGroup;
	private view = '[data-component="transfers-to-omni"]';
	private viewHeight = 0;
	active = true;
	private today: number = Date.now();
	private scheduleError: boolean;
	// private minDate: Date = new Date();
	private minDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
	// scheduleSpan = false;
	public scheduleSpan = false;
	date: any;

	constructor(private formBuilder: FormBuilder, private transferOmniService: TransfersOmniService) {

		this.scheduleSpan = this.transferOmniService.scheduleSpan;

		this.form = formBuilder.group({
			'value': [null, Validators.required],
			'transferDate': ['today', Validators.required],
			'scheduleDate': [null]
		});
	}

	dateFormat(e) {
		let newDate = e.target.value.toString();
		newDate = newDate.replace(/\D/g, '');
		newDate = newDate.replace(/(\d{2})(\d)/, '$1/$2');
		newDate = newDate.replace(/(\d{2})(\d)/, '$1/$2');
		this.scheduleError = true;
		if (newDate.length === 10) {
			this.scheduleError = false;
			const data = moment(newDate, 'DD/MM/YYYY');
			if (data.isValid())
			{
				if (data.isAfter(moment()))
				{
					e.target.value = newDate;
					this.form.get('scheduleDate').setValue(data.toDate());
					this.form.get('scheduleDate').setErrors(null);
				}
				else
				{
					e.target.value = newDate;
					this.form.get('scheduleDate').setErrors({ 'required': true });
					this.scheduleError = true;
				}
			}
			else
			{
				e.target.value = newDate;
				this.form.get('scheduleDate').setErrors({ 'required': true });
				this.scheduleError = true;
			}
			// const arrDate = newDate.split('/');
			// const finalDate = arrDate[1] + '/' + arrDate[0] + '/' + arrDate[2];
			// const novaData = new Date(finalDate);
			// if (!isNaN(novaData.getTime())) {
			// 	this.form.get('scheduleDate').setValue(new Date(finalDate));
			// 	this.form.get('scheduleDate').setErrors(null);
			// } else {
			// 	e.target.value = newDate;
			// 	this.form.get('scheduleDate').setErrors({ 'required': true });
			// 	this.scheduleError = true;
			// }
		}else {
			e.target.value = newDate;
		}
	}

	verifyZero() {
		if ($('.currency-field').val() === '0,00') {
			$('.currency-field').val('');
		}
	}

	ngOnInit() {
		AppEventDispatcher.listen(TransfersOmniEventType.STEPS.TRANSFER_DATA, data => {
			if (data.show) {
				this.setForm.emit(this.form);
				this.show();
			} else {
				this.hide();
			}
		});

		AppEventDispatcher.listen(TransfersOmniEventType.TRANSFER.SEND, () => {
			this.hide();
		});

		AppEventDispatcher.listen(ModalErrorEventType.MODAL.CANCEL, data => {
			AppEventDispatcher.dispatch(EventTypes.MODAL_ERROR.MODAL_CLOSE, {  });
		});

		AppEventDispatcher.listen(ModalErrorEventType.MODAL.OK, data => {
			AppEventDispatcher.dispatch(EventTypes.MODAL_ERROR.MODAL_CLOSE, {  });
		});

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(TransfersOmniEventType.STEPS.TRANSFER_DATA);
		AppEventDispatcher.removeListener(TransfersOmniEventType.TRANSFER.SEND);
		AppEventDispatcher.removeListener(ModalErrorEventType.MODAL.CANCEL);
		AppEventDispatcher.removeListener(ModalErrorEventType.MODAL.OK);
	}

	show() {
		this.checkDateOption();

		const containerHeight = this.getStepHeight();

		this.viewHeight = containerHeight;

		TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
		TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
		AppEventDispatcher.dispatch(TransfersOmniEventType.MODAL.TRUE_MODAL, { data: true });
		$('.currency-field').val('');

	}

	setTransferData() {
		this.transferData.value = this.form.controls.value.value;

		if (this.form.controls.transferDate.value === 'today') {
			this.transferData.date = new Date();
			this.transferData.dateLabel = moment(new Date()).format('DD/MM/YYYY');
			this.transferData.dateType = 'today';
		} else {
			this.transferData.date = this.form.controls.scheduleDate.value;
			this.transferData.dateLabel = moment(this.form.controls.scheduleDate.value).format('DD/MM/YYYY');
			this.transferData.dateType = 'schedule';
		}

	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 30;
	}

	checkDateOption(type = 'today') {
		if (type === 'schedule') {
			this.scheduleSpan = true;
			this.transferOmniService.scheduleSpan = true;

			AppEventDispatcher.dispatch(TransfersOmniEventType.MODAL.TRUE_MODAL, { data: false });

			this.form.controls.scheduleDate.setValidators(Validators.required);
			this.form.controls.scheduleDate.updateValueAndValidity();

			if (moment().isAfter(this.form.controls.scheduleDate.value)) {
				this.scheduleError = true;
			} else {
				this.scheduleError = false;
			}

			this.form.controls.transferDate.setValue('schedule');

		} else {
			this.scheduleSpan = false;
			this.transferOmniService.scheduleSpan = false;
			AppEventDispatcher.dispatch(TransfersOmniEventType.MODAL.TRUE_MODAL, { data: true });

			this.form.controls.scheduleDate.clearValidators();
			this.form.controls.scheduleDate.setValue('');
		}
	}


	hide() {
		this.setTransferData();

		this.preload(true);

		let time = 1;
		const timeLoader = setInterval(() => {
			time++;
		}, 1000);

		this.transferOmniService.sendTransfer(this.transferData).subscribe( data => {

			this.transferData.id = data.Retorno.TransferenciaID;
			this.transferData.favoredName = data.Retorno.DadosEntrada.NomeFavorecido;
			this.transferData.favoredCpfCnpj = data.Retorno.DadosEntrada.CPFCNPJFavorecido;
			this.transferData.bankCode = data.Retorno.DadosEntrada.CodBancoDestino;
			this.transferData.bankDesc = data.Retorno.DadosEntrada.DescBancoDestino;
			this.transferData.destinationAgency = data.Retorno.DadosEntrada.CodAgenciaDestino.toString();
			this.transferData.destinationAccount = data.Retorno.DadosEntrada.CodContaDestino;

			if (time > 3) {
				this.preload(false);
				this.hideAfterSend();
			}	else {
				TweenMax.delayedCall(3 - time, () => {
					this.preload(false, 3 - time);
					this.hideAfterSend();
				});
			}
			clearInterval(timeLoader);

		}, data => {

			AppEventDispatcher.dispatch(TransfersOmniEventType.ERROR, {step: TransfersOmniEventType.STEPS.FAVORED_DATA});

			if (time > 3) {
				this.preload(false);
				this.setForm.emit(this.form);
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: data.error.Mensagem });
			}	else {
				TweenMax.delayedCall(3 - time, () => {
					this.preload(false, 3 - time);
					this.setForm.emit(this.form);
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: data.error.Mensagem });
				});
			}
			clearInterval(timeLoader);


		});

	}


	hideAfterSend() {

		TweenMax.delayedCall(1, () => {

			AppEventDispatcher.dispatch(TransfersOmniEventType.STEPS.TRANSFER_CONFIRMATION, {show: true});

			TweenMax.to(this.view, 2.8, { left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}});

		});

	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="transfers-omni"] .content', show: active, delay: delay});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/transfers-omni/transfers-to-omni/transfers-to-omni.component.ts